import { combineReducers } from '@reduxjs/toolkit';
import { commissionModuleReducer } from '../features/commission';
import { routerReducer } from '../middlewares/routerMiddleware';
export var reducers = combineReducers({
    router: routerReducer,
    commission: commissionModuleReducer,
});
